import {
  AdvertiserType,
  type Shop,
  type UserProfileInfo,
} from '@sbt-web/network/types';
import { DEFAULT_ADVERTISER_NAME } from '@/shared/constants';

export function isCompany(advertiserType: number | AdvertiserType): boolean {
  return (
    advertiserType === AdvertiserType.Pro ||
    advertiserType === AdvertiserType.Company
  );
}

export const isPro = (advertiserType: number | AdvertiserType): boolean =>
  advertiserType === AdvertiserType.Pro;

export function getAdvertiserName(
  advertiserType: number,
  shop: Shop | null,
  advertiserProfile: UserProfileInfo | null
): string {
  const name = advertiserProfile?.username ?? DEFAULT_ADVERTISER_NAME;

  if (isPro(advertiserType)) {
    return shop?.name ?? name;
  }

  return name;
}
